import { render, staticRenderFns } from "./AddLesion.vue?vue&type=template&id=ad74589c"
import script from "./AddLesion.vue?vue&type=script&setup=true&lang=js"
export * from "./AddLesion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports